import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import { get_token, get_user_details} from "@/router";

export default {
  components: {
    Sidebar,
    Navbar
  },
  data() {
    return ({
        membership_payment_history: [],
        token_exists: false,
    });
  },
  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details()
      this.filter_membership_payment_history().then(() => {
      this.$nextTick(() => {
        $('.table').DataTable({
          paging: true,
          searching: true,
          ordering: true,
          info: true,
          lengthChange: true,
          pageLength: 10,
          language: {
            paginate: {
              previous: "Previous",
              next: "Next"
            },
            info: "Showing _START_ to _END_ of _TOTAL_ entries",
            infoEmpty: "No entries available"
          },
          sortColumn: '',
          sortDirection: 'asc'
        });
      });
    });
  },
  methods: {
    getToken() {
      return get_token();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
    processMembershipPaymentResponse(data) {
    const history = data?.payment_history || [];

    this.membership_payment_history = history;
    const first = history[0] || {};
    this.assign_basic_details(first);
    this.assign_user_details(first.user);
    this.assign_membership_details(first.membership);
    this.assign_payment_status(first.payment_status);
  },
  assign_basic_details(entry) {
  this.is_active = entry?.is_active || false;
  this.membership_payment_history_id = entry?.id || null;
  this.renewal_date = entry?.valid_until || null;
},

assign_user_details(user) {
  this.user_first_name = user?.first_name || '';
  this.user_last_name = user?.last_name || '';
},

assign_membership_details(membership) {
  this.membership_name = membership?.name || '';
  this.membership_type = membership?.membership_type?.name || '';
  this.billing_cycle = membership?.billing_cycle?.name || '';
  this.membership_price = membership?.membership_pricing?.[0]?.price || 0;
},

assign_payment_status(status) {
  this.payment_status = status?.status || [];
},
    filter_membership_payment_history() {
      this.token_exists = get_token();

      const membership_id= this.$route.params.membership_id || null;

        const payload = {
          membership_id: membership_id
      };
      return new Promise((resolve) => {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_membership_payment_history/`,
        method: "POST",
        data: JSON.stringify(payload),
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {"Content-Type": "application/json" },
        success: (response) => {
          this.processMembershipPaymentResponse(response.data);
          resolve();
        },
        complete: () => {
          this.isLoading = false;
        },
      });
        });
    },

  }
};

